export const KEYWORD_SOFT_WARN = 25;
export const KEYWORD_HARD_CAP = 100;
export const MIN_INTERVAL = 5;
export const MAX_RESULTS_MIN = 10;
export const MAX_RESULTS_MAX = 100;
export const DISPLAY_NAME_MAX = 80;

const USERNAME_RE = /^[A-Za-z0-9_]{1,15}$/;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeUsername(raw) {
  if (!raw) return "";
  return String(raw).trim().replace(/^@+/, "");
}

export function isValidUsername(u) {
  return USERNAME_RE.test(u || "");
}

export function isValidEmail(e) {
  return EMAIL_RE.test((e || "").trim());
}

export function dedupeKeywords(list) {
  const seen = new Set();
  const out = [];
  for (const raw of list || []) {
    const trimmed = String(raw ?? "").trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}

export function dedupeEmails(list) {
  const seen = new Set();
  const out = [];
  for (const raw of list || []) {
    const trimmed = String(raw ?? "").trim();
    if (!trimmed) continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out;
}

export const MATCH_MODES = [
  { value: "word_boundary", label: "Word boundary" },
  { value: "substring", label: "Substring" },
];

export const WORD_BOUNDARY_CAVEAT =
  "Word boundary mode only matches whole words (e.g. \"fraud\" matches \"fraud case\" but not \"defrauded\"). Safer for English keywords — fewer false positives.";

export const SUBSTRING_CAVEAT =
  "Substring mode bypasses word boundaries. Required for non-ASCII (Arabic, CJK). Short keywords will over-match — keep them specific.";

export const MAX_RESULTS_HELP =
  "Caps how many recent tweets are fetched per account on each tick. Higher values catch more activity on busy accounts but cost more API quota.";

export const KEYWORD_SOFT_WARN_COPY =
  "Large keyword lists can slow matching and increase noise.";

export const ACTIVE_NEEDS_KEYWORDS_COPY =
  "Add at least one keyword before activating.";
